import { render, staticRenderFns } from "./SortableHeaderCell.vue?vue&type=template&id=0bf1ba51&"
import script from "./SortableHeaderCell.vue?vue&type=script&lang=js&"
export * from "./SortableHeaderCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports